import React from 'react';

import classes from '../installPics.css';

import ThirdInstallPic from '../../../../../../../assets/ThirdInstallImg.jpg';

const ThirdInstallImg = () => (
    <div className={classes.installImages}>
        <img alt="A passthrough box hides wire and conduit runs in the attic, making your installation cleaner and more sleek." src={ThirdInstallPic} className={classes.installImg} />
    </div>
);


export default ThirdInstallImg;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/SalesLogic/InstallImages/PitchedRoofImages/ThirdInstallImg.js